import type { Market } from '@backmarket/http-api'
import { getBrowserCookie } from '@backmarket/utils/cookies/getBrowserCookie'

import { cookieNames } from '../constants'
import type { ContextData, TrackingConfig } from '../types'

export function getInitialContext(
  market: Market,
  features: Record<string, unknown>,
  featureFlags: Record<string, unknown>,
  config: TrackingConfig,
  visitorId: string,
  sessionId: string,
) {
  const context: ContextData = {
    /* Experiments config
      // For every flag, is its value different from its default one
      isDefaultSegment: true,
      // get experiments (flags) from the config (flags/config.js) + get experiments from server req – needs to be clarified.
      abtest: [],
    */

    // Feature flags
    flags: featureFlags,

    // Market config
    currencyCode: market.defaultCurrency,
    locale: market.defaultLocale,
    country: market.countryCode,
    isCountryRollout: market.status === 'OPEN',

    // Module config
    service: config.service,
    release: config.version,

    // Identification
    visitorId,
    sessionId,
  }

  // GDPR config
  if (process.client) {
    context.gdpr = {
      functional: true,
      advertising: getBrowserCookie(cookieNames.Advertising) === 'true',
      analytics: getBrowserCookie(cookieNames.Analytics) === 'true',
      userExperience: getBrowserCookie(cookieNames.UserExperience) === 'true',
    }
  }

  // Features
  if (
    features.trustmark !== undefined &&
    typeof features.trustmark === 'string'
  )
    context.trustmark = features.trustmark

  if (features.showCarrier !== undefined)
    context.hasCarrierFilters = Boolean(features.showCarrier)

  if (features.vatIncluded !== undefined)
    context.hasVATIncluded = Boolean(features.vatIncluded)

  if (
    features.buyback !== undefined &&
    features.buyback !== null &&
    typeof features.buyback === 'object' &&
    'enabled' in features.buyback
  )
    context.hasBuyBack = Boolean(features.buyback.enabled)

  return context
}
